(function (global) {
  'use strict';

  function text(node) {
    return node ? node.textContent.trim() : '';
  }

  function absoluteUrl(value, base) {
    if (!value) return '';
    try { return new URL(value, base).href; } catch (error) { return ''; }
  }

  function parseInstant(value) {
    var parsed = Date.parse(value || '');
    return Number.isFinite(parsed) ? parsed : null;
  }

  function write(root, selector, value) {
    var node = root.querySelector(selector);
    if (node && node.textContent !== value) node.textContent = value;
  }

  function writeCountdown(root, distance) {
    var total = Math.max(0, Math.floor(distance / 1000));
    write(root, '[data-days]', String(Math.floor(total / 86400)));
    write(root, '[data-hours]', String(Math.floor(total % 86400 / 3600)).padStart(2, '0'));
    write(root, '[data-minutes]', String(Math.floor(total % 3600 / 60)).padStart(2, '0'));
    write(root, '[data-seconds]', String(total % 60).padStart(2, '0'));
  }

  function validSourceCard(card) {
    var start = parseInstant(card.dataset.startAt);
    var end = parseInstant(card.dataset.endAt);
    return Boolean(card.dataset.eventId && start !== null && end !== null && end > start) &&
      card.dataset.plannerStatus === 'approved' &&
      card.dataset.visibility === 'public_when_active' &&
      card.dataset.offerStatus !== 'inactive';
  }

  function cardIsActive(card, now) {
    var start = parseInstant(card.dataset.startAt);
    var end = parseInstant(card.dataset.endAt);
    return start !== null && end !== null && now >= start && now < end;
  }

  function makeElement(name, className, value) {
    var node = global.document.createElement(name);
    if (className) node.className = className;
    if (value) node.textContent = value;
    return node;
  }

  function responsiveImage(value) {
    try {
      var url = new URL(value, global.location.origin);
      if (url.hostname !== 'cdn.shopify.com' || !url.pathname.startsWith('/s/files/') || url.searchParams.has('width') || url.searchParams.has('height')) return null;
      var widths = [480, 720, 960, 1440];
      var sources = widths.map(function (width) {
        var sized = new URL(url.href);
        sized.searchParams.set('width', String(width));
        return sized.href + ' ' + width + 'w';
      });
      url.searchParams.set('width', '1440');
      return { src: url.href, srcset: sources.join(', '), sizes: '(max-width: 959px) calc(100vw - 36px), (max-width: 1464px) calc((100vw - 64px) * 0.525), 735px' };
    } catch (_) { return null; }
  }

  function buildCard(source, sourceUrl, root, imageData) {
    var card = makeElement('article', 'dm-home-events__card');
    card.dataset.dmHomeEventCard = '';
    card.dataset.eventId = source.dataset.eventId;
    card.dataset.startAt = source.dataset.startAt;
    card.dataset.endAt = source.dataset.endAt;
    card.hidden = true;
    card.setAttribute('aria-hidden', 'true');

    var media = makeElement('div', 'dm-home-events__media');
    if (imageData) {
      var image = global.document.createElement('img');
      image.alt = imageData.alt || '';
      image.loading = 'lazy';
      image.decoding = 'async';
      var optimized = responsiveImage(imageData.src);
      if (optimized) {
        image.setAttribute('data-image-sizes', optimized.sizes);
        image.setAttribute('data-image-srcset', optimized.srcset);
      }
      image.setAttribute('data-image-src', optimized ? optimized.src : absoluteUrl(imageData.src, sourceUrl));
      media.appendChild(image);
    }

    var content = makeElement('div', 'dm-home-events__content');
    var subtitle = text(source.querySelector('.promo-event__eyebrow'));
    var title = text(source.querySelector('h2'));
    var offer = text(source.querySelector('.promo-event__offer'));
    var terms = text(source.querySelector('.promo-event__terms'));
    if (subtitle) content.appendChild(makeElement('p', 'dm-home-events__subtitle fs-accent', subtitle));
    if (title) content.appendChild(makeElement('h2', 'dm-home-events__title ff-heading fs-heading-2-base', title));

    var body = makeElement('div', 'dm-home-events__body rte ff-body fs-body-100');
    if (offer) body.appendChild(makeElement('p', 'dm-home-events__offer', offer));
    if (terms) body.appendChild(makeElement('p', 'dm-home-events__terms', terms));
    content.appendChild(body);

    var timer = makeElement('p', 'dm-home-events__timer ff-body fs-body-75');
    timer.appendChild(makeElement('span', '', root.dataset.countdownLabel || 'Offer ends in'));
    var time = makeElement('time', 'dm-home-events__time');
    time.dateTime = source.dataset.endAt;
    [['days', 'dayUnit', '0'], ['hours', 'hourUnit', '00'], ['minutes', 'minuteUnit', '00'], ['seconds', 'secondUnit', '00']].forEach(function (part) {
      var span = makeElement('span');
      var strong = makeElement('strong', '', part[2]);
      strong.setAttribute('data-' + part[0], '');
      span.appendChild(strong);
      span.appendChild(global.document.createTextNode(root.dataset[part[1]] || part[0].charAt(0)));
      time.appendChild(span);
    });
    timer.appendChild(time);
    content.appendChild(timer);

    var sourceLink = source.querySelector('a');
    if (sourceLink && sourceLink.getAttribute('href')) {
      var actions = makeElement('div', 'dm-home-events__actions');
      var link = makeElement('a', 'btn btn--primary', text(sourceLink));
      link.href = absoluteUrl(sourceLink.getAttribute('href'), sourceUrl);
      actions.appendChild(link);
      content.appendChild(actions);
    }

    card.appendChild(media);
    card.appendChild(content);
    return card;
  }

  function buildManifestCard(event, root) {
    var source = makeElement('article');
    source.dataset.eventId = event.eventId;
    source.dataset.startAt = new Date(event.startsAtMs).toISOString();
    source.dataset.endAt = new Date(event.endsAtExclusiveMs).toISOString();
    source.appendChild(makeElement('h2', '', event.presentation.title));
    source.appendChild(makeElement('p', 'promo-event__offer', event.presentation.offerText));
    source.appendChild(makeElement('p', 'promo-event__terms', event.presentation.termsText));
    var link = makeElement('a', '', event.presentation.buttonLabel);
    link.href = event.presentation.destinationUrl;
    source.appendChild(link);
    return buildCard(source, global.location.origin, root, { src: event.presentation.imageUrl, alt: event.presentation.imageAlt });
  }

  function initialize(root) {
    if (!root || root.dataset.dmHomeEventsInitialized === 'true') return;
    root.dataset.dmHomeEventsInitialized = 'true';
    var viewport = root.querySelector('[data-dm-home-events-viewport]');
    var navigation = root.querySelector('[data-dm-home-events-navigation]');
    var dots = root.querySelector('[data-dm-home-events-dots]');
    var previous = root.querySelector('[data-dm-home-events-previous]');
    var next = root.querySelector('[data-dm-home-events-next]');
    var allCards = [];
    var activeCards = [];
    var selectedIndex = 0;
    var interval = null;
    var refresher = null;
    var alive = true;
    var events = [];
    var releaseExpiresAtMs = 0;
    var releaseKey = null;
    var now = function () { return NaN; };
    var core = global.EventsManifestCore;
    var cardCache = new Map();
    var lastAdvance = Date.now();
    var paused = false;
    var reduceMotion = global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var autoplayMilliseconds = Math.max(4000, Number(root.dataset.autoplaySeconds || 6) * 1000);

    function renderSelected() {
      activeCards.forEach(function (card, index) {
        var retainImage = index === selectedIndex || index === (selectedIndex + 1) % activeCards.length;
        var image = card.querySelector('img');
        if (image && !retainImage && (image.getAttribute('src') || image.getAttribute('srcset'))) {
          image.removeAttribute('src');
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
        }
      });
      activeCards.forEach(function (card, index) {
        var selected = index === selectedIndex;
        var image = card.querySelector('img');
        var retainImage = selected || index === (selectedIndex + 1) % activeCards.length;
        if (image && retainImage && !image.getAttribute('src')) {
          image.loading = 'eager';
          var sizes = image.getAttribute('data-image-sizes');
          var sourceSet = image.getAttribute('data-image-srcset');
          if (sizes) image.setAttribute('sizes', sizes);
          if (sourceSet) image.setAttribute('srcset', sourceSet);
          image.setAttribute('src', image.getAttribute('data-image-src'));
        }
        if (card.hidden !== !selected) card.hidden = !selected;
        var ariaHidden = selected ? 'false' : 'true';
        if (card.getAttribute('aria-hidden') !== ariaHidden) card.setAttribute('aria-hidden', ariaHidden);
        if (selected) writeCountdown(card, parseInstant(card.dataset.endAt) - now());
      });
      Array.prototype.forEach.call(dots ? dots.querySelectorAll('button') : [], function (dot, index) {
        var ariaCurrent = index === selectedIndex ? 'true' : 'false';
        if (dot.getAttribute('aria-current') !== ariaCurrent) dot.setAttribute('aria-current', ariaCurrent);
      });
    }

    function select(index) {
      if (activeCards.length < 2) return;
      selectedIndex = (index + activeCards.length) % activeCards.length;
      lastAdvance = Date.now();
      renderSelected();
    }

    function buildNavigation() {
      if (!navigation || !dots) return;
      dots.textContent = '';
      activeCards.forEach(function (card, index) {
        var dot = makeElement('button', 'dm-home-events__dot');
        dot.type = 'button';
        dot.setAttribute('aria-label', (root.dataset.eventLabel || 'Event') + ' ' + String(index + 1));
        dot.addEventListener('click', function () { select(index); });
        dots.appendChild(dot);
      });
      if (navigation.hidden !== (activeCards.length < 2)) navigation.hidden = activeCards.length < 2;
    }

    function reconcile() {
      var at = now();
      var admitted = Number.isFinite(at) && at < releaseExpiresAtMs ? events.filter(function (event) {
        return core.active(event, at) && (event.discount.kind !== 'fixed_cents' || event.discount.currency === root.dataset.currency);
      }).sort(function (a, b) { return a.endsAtExclusiveMs - b.endsAtExclusiveMs || a.eventId.localeCompare(b.eventId); }) : [];
      var wanted = new Set(admitted.map(function (event) { return event.eventId; }));
      cardCache.forEach(function (card, id) {
        if (!wanted.has(id)) { if (card.parentNode) card.parentNode.removeChild(card); cardCache.delete(id); }
      });
      var nextActive = admitted.map(function (event) {
        var card = cardCache.get(event.eventId);
        if (!card) { card = buildManifestCard(event, root); cardCache.set(event.eventId, card); }
        if (card.parentNode !== viewport) viewport.appendChild(card);
        return card;
      });
      allCards = nextActive;
      var orderChanged = nextActive.length !== activeCards.length || nextActive.some(function (card, index) { return card.dataset.eventId !== activeCards[index].dataset.eventId; });
      var changed = nextActive.length !== activeCards.length || nextActive.some(function (card, index) { return card !== activeCards[index]; });
      activeCards = nextActive;
      if (orderChanged || selectedIndex >= activeCards.length) selectedIndex = 0;
      var activeCount = String(activeCards.length);
      if (root.dataset.activeEventCount !== activeCount) {
        root.classList.toggle('is-ready', activeCards.length > 0);
        root.dataset.activeEventCount = activeCount;
      }
      if (changed) {
        buildNavigation();
        lastAdvance = Date.now();
      }
      if (!activeCards.length) return;
      if (!global.document.hidden && !paused && !reduceMotion && activeCards.length > 1 && Date.now() - lastAdvance >= autoplayMilliseconds) {
        selectedIndex = (selectedIndex + 1) % activeCards.length;
        lastAdvance = Date.now();
      }
      renderSelected();
    }

    if (previous) previous.addEventListener('click', function () { select(selectedIndex - 1); });
    if (next) next.addEventListener('click', function () { select(selectedIndex + 1); });
    root.addEventListener('mouseenter', function () { paused = true; });
    root.addEventListener('mouseleave', function () { paused = false; lastAdvance = Date.now(); });
    root.addEventListener('focusin', function () { paused = true; });
    root.addEventListener('focusout', function (event) {
      if (!root.contains(event.relatedTarget)) { paused = false; lastAdvance = Date.now(); }
    });

    function onResume() {
      if (global.document.hidden) return;
      lastAdvance = Date.now();
      if (refresher) refresher.refreshNow();
      reconcile();
    }
    try {
      if (!viewport || !core || !global.EventsManifestRefresh || !/^[A-Z]{3}$/.test(root.dataset.currency)) throw new Error('Missing manifest dependencies');
      refresher = global.EventsManifestRefresh.create({
        url: root.dataset.sourceUrl || '/pages/events',
        identity: { storeKey: root.dataset.storeKey, shopGid: root.dataset.shopGid },
        maxAgeMs: 900000,
        onAccept: function (envelope, trustedNow) {
          if (!alive) return;
          var nextReleaseKey = envelope.manifestVersion + ':' + envelope.releaseId;
          if (releaseKey !== nextReleaseKey) {
            cardCache.forEach(function (card) { if (card.parentNode) card.parentNode.removeChild(card); });
            cardCache.clear();
          }
          releaseKey = nextReleaseKey;
          events = envelope.events;
          releaseExpiresAtMs = envelope.releaseExpiresAtMs;
          now = trustedNow;
          if (root.dataset.sourceStatus !== 'loaded') root.dataset.sourceStatus = 'loaded';
          var rejectedCount = String(envelope.rejected && envelope.rejected.length || 0);
          if (root.dataset.eventsRejectedCount !== rejectedCount) root.dataset.eventsRejectedCount = rejectedCount;
          reconcile();
        },
        onFailure: function () {
          if (!alive) return;
          if (root.dataset.sourceStatus !== 'retrying') root.dataset.sourceStatus = 'retrying';
          reconcile();
        }
      });
      interval = global.setInterval(reconcile, 1000);
      global.document.addEventListener('visibilitychange', onResume);
      global.addEventListener('focus', onResume);
      global.addEventListener('pageshow', onResume);
    } catch (_) {
      root.dataset.sourceStatus = 'error';
      root.classList.remove('is-ready');
    }

    root.dmHomeEventsDestroy = function () {
      alive = false;
      if (interval) global.clearInterval(interval);
      if (refresher) refresher.destroy();
      global.document.removeEventListener('visibilitychange', onResume);
      global.removeEventListener('focus', onResume);
      global.removeEventListener('pageshow', onResume);
      delete root.dmHomeEventsDestroy;
      delete root.dataset.dmHomeEventsInitialized;
    };
  }

  function initializeAll(container) {
    var scope = container && container.querySelectorAll ? container : global.document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-dm-home-events]'), initialize);
    if (scope.matches && scope.matches('[data-dm-home-events]')) initialize(scope);
  }

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () { initializeAll(global.document); });
    } else {
      initializeAll(global.document);
    }
    global.document.addEventListener('shopify:section:load', function (event) { initializeAll(event.target); });
    global.document.addEventListener('shopify:section:unload', function (event) {
      Array.prototype.forEach.call(event.target.querySelectorAll('[data-dm-home-events]'), function (root) {
        if (root.dmHomeEventsDestroy) root.dmHomeEventsDestroy();
      });
    });
  }

  global.DellamodaHomeEvents = {
    cardIsActive: cardIsActive,
    validSourceCard: validSourceCard,
    initializeAll: initializeAll
  };
}(typeof window !== 'undefined' ? window : globalThis));

